import aiAxios from "services/aiAxios";

export function useBDS() {

    const onUpdateToday = async (cb) => {
        try {
            const { data } = await aiAxios.post(`/crawl_custom_date`, {});
            console.log("🚀 ~ onGetStats ~ data:", data)
            if (data) {
                return cb?.(data)
            }
        } catch (error) {
            return cb?.([])
        }
    }

    // /stats
    const onGetStats = async (type = 'apartment', cb) => {
        try {
            const { data } = await aiAxios.post(`/stats`, {
                ptype: type
            });
            console.log("🚀 ~ onGetStats ~ data:", data)
            if (data) {
                return cb?.(data)
            }
        } catch (error) {
            return cb?.([])
        }
    }

    const onGetData = async (type = 'apartment', cb) => {
        try {
            const { data } = await aiAxios.post(`/excel_json`, {
                ptype: type
            });
            if (data?.rows?.length) {
                return cb?.(data.rows.map((e, i) => ({ ...e, 'NO': i + 1 })))
            }
        } catch (error) {
            return cb?.([])
        }
    }

    const onStatsAll = async (type = 'apartment', cb) => {
        try {
            const { data } = await aiAxios.post(`/stats_on_5th`, {
                ptype: type
            });
            console.log("🚀 ~ onStatsAll ~ data:", data)
            if (data?.dates) {
                const { dates, list_num_sold, list_num_suumo, list_num_remain, list_num_new, ward_sales } = data;
                //                
                return cb?.({
                    stats_status: {
                        list_sold: dates.map((e, i) => ({ "month": e, "成約物件": list_num_sold[i] })),
                        list_remain: dates.map((e, i) => ({ "month": e, "先月残掲載物件": list_num_remain[i] })),
                        list_new: dates.map((e, i) => ({ "month": e, "新着物件": list_num_new[i] })),
                        list_suumo: dates.map((e, i) => ({ "month": e, "SUUMOの掲載中物件": list_num_suumo[i] })),
                    },
                    stats_sales: Object.entries(ward_sales).map(([k, v]) => ({ area: k, quantity: v }))
                })
            }
        } catch (error) {
            return cb?.([])
        }
    }

    return { onGetData, onGetStats, onStatsAll, onUpdateToday }
}
